/** True when the competition round row is marked finished (all matches terminal). */
export function isRoundFinished(round) {
  if (!round) return false;
  const status = String(round.status || '').toLowerCase();
  return status === 'finished' || status === 'f';
}

/**
 * Rank label for standings tables.
 * Medals only when showMedals is true (finished round leagues); otherwise numbered.
 */
export function formatStandingRank(rank, { showMedals = false, numberedSuffix = '.' } = {}) {
  if (showMedals && rank >= 1 && rank <= 3) {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
  }
  return `${rank}${numberedSuffix}`;
}
